import React from "react";

import "./GenericTable.css";
import ResizableDraggableTable from "../resizeableTable/ResizableDraggableTable";

function GenericTable({initialColumns,tabData,activeTab, setActiveTab , sideCardTabConfig,showMoreModal,setShowMoreModal,titleForSideCard,loading,disableHeader}) {
  // console.log("GenericTable",activeTab,setActiveTab)
  return (
    <>
      <ResizableDraggableTable initialColumns={initialColumns} tabData={tabData} sideCardTabConfig={sideCardTabConfig} showMoreModal={showMoreModal} setShowMoreModal={setShowMoreModal} titleForSideCard={titleForSideCard} activeTab={activeTab} setActiveTab={setActiveTab} loading={loading} disableHeader={disableHeader}/>
    </>
  );
}

export default GenericTable;
